import styled from "styled-components";
export const BottomAnchor = styled.div `
  position: absolute;
  pointer-events: none;
  width: 1px;
  height: 1px;

  // not sure if this does anything but might not work otherwise with rounded corners
  left: 50%;

  // experimentally chosen, enough to be visible at all zoom levels (which apparently lead to huge calculation errors)
  margin-top: -4px;
`;
BottomAnchor.defaultProps = {
    "aria-hidden": true
};
